import type {ReactElement} from "react";
import React from "react";
import {AppBar, Grid, Paper} from "@mui/material";
import {MainFooter} from "../main/MainFooter";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import MithraMainLogo from '../icons/logo/MithraMainLogo.svg?react';

type Props = {
    className?: string,
    content: ReactElement,
    minHeight?: string,
};

export const FullPageCard: React.FC<Props> = ({className, content, minHeight}) => <>
    <Grid className={"full-page-card vh-100" + (className ? ` ${className}` : '')}
          container justifyContent="center" direction="column">
        <Grid>
            <Container>
                <Grid container justifyContent="center">
                    <Grid
                        size={{
                            xs: 9,
                            sm: 6,
                            md: 4
                        }}>

                        {/*Small header*/}
                        <AppBar id="main-header" className="small" position="relative" elevation={2}>
                            <Toolbar>
                                <MithraMainLogo className="mithra-logo"/>
                            </Toolbar>
                        </AppBar>

                        {/*Content*/}
                        <Paper style={{minHeight: minHeight}} elevation={2} square>
                            {content}
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    </Grid>
    <div style={{position: 'absolute', bottom: 0, left: 0, right: 0}}>
        <MainFooter/>
    </div>
</>;
